




































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import _ from 'lodash'
import time from '@/utils/time'
import { loadConnection, createConnection, updateConnection, loadSuggestConnections } from '@/utils/api/connection'
import { emptyToNull } from '@/utils/handleString'
import { getClientId } from '@/utils/idGenerator'
import { getMQTTProtocol, getDefaultRecord } from '@/utils/mqttUtils'
import Editor from '@/components/Editor.vue'
import KeyValueEditor from '@/components/KeyValueEditor.vue'

@Component({
  components: {
    Editor,
    KeyValueEditor,
  },
})
export default class ConnectionCreate extends Vue {
  @Prop({ required: true }) public oper!: 'edit' | 'create' | undefined

  @Getter('currentLang') private getterLang!: Language
  @Getter('advancedVisible') private getterAdvancedVisible!: boolean
  @Getter('willMessageVisible') private getterWillMessageVisible!: boolean
  @Getter('currentTheme') private theme!: Theme
  @Getter('allConnections') private allConnections!: ConnectionModel[] | []

  @Action('CHANGE_ACTIVE_CONNECTION') private changeActiveConnection!: (payload: Client) => void
  @Action('TOGGLE_ADVANCED_VISIBLE') private toggleAdvancedVisible!: (payload: { advancedVisible: boolean }) => void
  @Action('TOGGLE_WILL_MESSAGE_VISIBLE')
  private toggleWillMessageVisible!: (payload: { willMessageVisible: boolean }) => void

  private willMessageVisible = true
  private advancedVisible = true
  private payloadType = 'plaintext'
  private willLabelWidth = 180
  private suggestConnections: ConnectionModel[] | [] = []
  private oldName = ''

  private defaultRecord: ConnectionModel = getDefaultRecord()

  private record: ConnectionModel = _.cloneDeep(this.defaultRecord)

  @Watch('oper')
  private handleCreateNewConnection(val: string) {
    if (val === 'create') {
      // reinit the form when page jump to creation page
      this.initRecord()
    }
  }

  get clientIdWithTime() {
    return this.record.clientIdWithTime
  }

  get rules() {
    return {
      name: [
        { required: true, message: this.$t('common.inputRequired') },
        { validator: this.validateName, trigger: 'blur' },
      ],
      clientId: [{ required: true, message: this.$t('common.inputRequired') }],
      path: [{ required: true, message: this.$t('common.inputRequired') }],
      host: [{ required: true, message: this.$t('common.inputRequired') }],
      port: [{ required: true, message: this.$t('common.inputRequired') }],
    }
  }

  get vueForm(): VueForm {
    return this.$refs.form as VueForm
  }

  private async loadDetail(id: string) {
    const res: ConnectionModel | undefined = await loadConnection(id)
    if (res) {
      this.record = res
      this.oldName = res.name
      this.record.protocol = getMQTTProtocol(res)
    }
  }

  private validateForm(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.vueForm.validate((valid: boolean) => {
        if (!valid) {
          resolve(false)
          return
        }

        resolve(true)
      })
    })
  }

  private async saveData() {
    const data = { ...this.record }
    data.properties = emptyToNull(data.properties)
    let res: ConnectionModel | null = null

    if (this.oper === 'create') {
      // create a new connection
      res = await createConnection({
        ...data,
        createAt: time.getNowDate(),
        updateAt: time.getNowDate(),
      })
    } else {
      // update a exisit connection
      if (data.id) {
        res = await updateConnection(data.id, { ...data, updateAt: time.getNowDate() })
      }
    }

    return res
  }

  private async handleSave(type: 'connect' | 'save') {
    const valid = await this.validateForm()
    if (!valid) {
      return
    }

    const res = await this.saveData()
    // Save failed
    if (!(res && res.id)) {
      const msgError = this.oper === 'create' ? this.$tc('common.createfailed') : this.$tc('common.editfailed')
      this.$message.error(msgError)
      return
    }

    if (type === 'save') {
      const { id } = this.$route.params
      this.$emit('refresh')
      this.handleBack(id)
      this.$message.success(this.$tc('common.saveSuccess'))
    } else {
      // update ActiveConnection & connect
      this.changeActiveConnection({
        id: res.id,
        client: {},
        messages: [],
      } as Client)
      this.$emit('connect')
      this.$router.push(`/recent_connections/${res.id}`)
    }
  }

  private handleActionCommand(command: 'save') {
    if (command === 'save') {
      this.handleSave('save')
    }
  }

  private setClientID() {
    this.record.clientId = getClientId()
  }

  // Reverse the status of clientIdWithTime.
  private reverseClientIDWithTime() {
    this.record.clientIdWithTime = !this.record.clientIdWithTime
  }

  private handleSSL(val: boolean) {
    const { protocol } = this.record
    this.changeProtocol(protocol, val)
    if (!val) {
      this.record.certType = ''
    }
  }

  private changeProtocol(protocol: Protocol | undefined, isSSL: boolean): void | boolean {
    if (!protocol) {
      return false
    }
    if (/ws/gi.test(protocol)) {
      this.record.protocol = isSSL ? 'wss' : 'ws'
    }
  }

  private handleBack(id: string) {
    if (this.oper === 'create' && id === '0') {
      this.$router.push('/recent_connections')
    } else {
      this.$router.push(`/recent_connections/${id}`)
    }
  }

  private handleCollapse(part: 'advanced' | 'willMessage') {
    if (part === 'advanced') {
      this.advancedVisible = !this.advancedVisible
      this.toggleAdvancedVisible({
        advancedVisible: this.advancedVisible,
      })
    } else if (part === 'willMessage') {
      this.willMessageVisible = !this.willMessageVisible
      this.toggleWillMessageVisible({
        willMessageVisible: this.willMessageVisible,
      })
    }
  }

  private async validateName(rule: FormRule, name: string, callBack: NameCallBack) {
    for (const connection of this.allConnections) {
      if (this.oper === 'create' && connection.name === name) {
        callBack(this.$tc('connections.duplicateName'))
      } else if (this.oper === 'edit' && name !== this.oldName && connection.name === name) {
        callBack(this.$tc('connections.duplicateName'))
      }
    }
  }

  private async loadData(reload: boolean = false): Promise<void> {
    this.suggestConnections = await loadSuggestConnections()
  }

  private createFilter(queryName: string) {
    return (connectionItem: ConnectionModel) => {
      return connectionItem.name.toLowerCase().indexOf(queryName.toLowerCase()) === 0
    }
  }

  private querySearchName(queryName: string, cb: SearchCallBack) {
    const connections = [...this.suggestConnections]
    const results = queryName ? connections.filter(this.createFilter(queryName)) : connections
    cb(results.reverse())
  }

  private handleSelectName(item: ConnectionModel) {
    const { id, ...oneConnection } = item
    oneConnection.clientId = getClientId()
    this.record = oneConnection
  }

  private initRecord() {
    const { id } = this.$route.params
    if (this.oper === 'create') {
      this.record = _.cloneDeep(this.defaultRecord)
    } else if (this.oper === 'edit' && id !== '0') {
      this.loadDetail(id)
    }
  }

  private created() {
    this.loadData()
    this.initRecord()
    this.advancedVisible = this.getterAdvancedVisible
    this.willMessageVisible = this.getterWillMessageVisible
  }
}
